
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KanbanState } from '../kanban.model';

@Component({
  name: 'ViewSetting',
  components: {},
})
export default class ViewSetting extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  switchLayoutTrello(): void {
    this.state.settings!.layout = 'trello';
    this.saveSettings();

    //TODO this is an ugly hack to trigger a refresh of the ui due to the layout variable change that should be triggered automatically by vue but isn't
    let x = this.state.settings;
    this.state.settings = null;
    this.state.settings = x;
  }

  switchLayoutList(): void {
    this.state.settings!.layout = 'list';
    this.saveSettings();

    //TODO this is an ugly hack to trigger a refresh of the ui due to the layout variable change that should be triggered automatically by vue but isn't
    let x = this.state.settings;
    this.state.settings = null;
    this.state.settings = x;
  }

  private async saveSettings(): Promise<void> {
    await this.state.settingsAPI.update('KanbanSettings', false, false, JSON.stringify(this.state.settings));
  }
}
